import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AvailableTariffs, UserAccountTariffSpecificLimits } from '@products/models/tariff-status.model';

export const TariffStatusActions = createActionGroup({
  source: 'Tariff status',
  events: {
    'Get user account tariffs limit status': (exhibitionId: number) => ({ exhibitionId }),
    'Get user account tariff specific limits status': (exhibitionId: number) => ({ exhibitionId }),
    'Set user account tariffs limit status': (userAccountTariffLimit: number) => ({ userAccountTariffLimit }),
    'Set user account tariff specific limits status': (
      userAccountTariffSpecificLimits: UserAccountTariffSpecificLimits
    ) => ({ userAccountTariffSpecificLimits }),
    'Set available tariffs status': props<{ availableTariffs: AvailableTariffs }>(),
    'Set released voucher available tariffs status': props<{ availableTariffs: AvailableTariffs }>(),
    'Set is tariff loading status': (isTariffLoading: boolean) => ({ isTariffLoading }),
    'Set is create contingent reservation loading status': (isCreateContingentReservationLoading: boolean) => ({
      isCreateContingentReservationLoading
    }),
    'Set is promo code discount loading status': (isPromoCodeDiscountLoading: boolean) => ({
      isPromoCodeDiscountLoading
    }),
    'Reset reducer': emptyProps()
  }
});
